import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Rss, ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cat, setCat] = useState('all');

  useEffect(() => {
    axios.get(`${API}/blog`).then(r => { setPosts(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const cats = ['all', ...new Set(posts.map(p => p.category))];
  const filtered = posts.filter(p => cat === 'all' || p.category === cat);

  return (
    <div className="min-h-screen pt-24" data-testid="blog-page">
      <section className="py-16 text-center">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <p className="t-label c-gold mb-4">The Journal</p>
          <h1 className="t-headline text-5xl md:text-6xl c-cream mb-4">Health & Wellness</h1>
          <div className="gold-line mx-auto mb-6" />
          <p className="t-body c-muted max-w-xl mx-auto mb-6">
            Expert insights on bee products, holistic health, and the science of natural wellness.
          </p>
          <a href="/api/rss/blog" target="_blank" rel="noopener noreferrer" className="t-label c-gold hover:c-cream transition-colors inline-flex items-center gap-2" data-testid="blog-rss-link">
            <Rss className="w-3 h-3" /> Subscribe via RSS
          </a>
        </div>
      </section>

      <section className="pb-8">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-wrap justify-center gap-6">
          {cats.map(c => (
            <button key={c} onClick={() => setCat(c)}
              className={`t-label text-[11px] pb-2 border-b transition-all ${cat === c ? 'c-cream border-bb-gold' : 'c-muted border-transparent hover:c-cream'}`}
              data-testid={`blog-filter-${c.toLowerCase()}`}
            >
              {c === 'all' ? 'All' : c}
            </button>
          ))}
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {loading ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">{[1,2,3].map(i => <div key={i} className="bg-bb-rich h-64 animate-pulse" />)}</div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map(post => (
                <Link key={post.id} to={`/blog/${post.slug}`} className="group bg-bb-rich border border-bb-border hover:border-bb-gold transition-colors" data-testid={`blog-post-${post.slug}`}>
                  <div className="aspect-video overflow-hidden">
                    <img src={post.image_url} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  </div>
                  <div className="p-6">
                    <span className="t-label c-gold text-[10px] block mb-3">{post.category}</span>
                    <h2 className="font-heading text-xl c-cream mb-3 group-hover:c-gold transition-colors">{post.title}</h2>
                    <p className="t-body text-sm c-muted mb-4 line-clamp-2">{post.excerpt}</p>
                    <span className="t-label text-[10px] c-muted group-hover:c-gold transition-colors">Read <ArrowRight className="inline w-3 h-3" /></span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
